module.exports = __webpack_public_path__ + "img/02.4420e7e6.png";